<template>
  <div>
    <el-upload
      class="upload-demo"
      action=""
      :multiple="false"
      :accept="accept"
      show-file-list
      :limit="uploadLimit"
      :on-remove="onRemove"
      :on-success="onSuccess"
      :on-error="onError"
      :before-upload="beforeUpload"
      :before-remove="beforeRemove"
      :on-exceed="onExceed"
      :on-preview="handlePictureCardPreview"
      :file-list="fileList"
      :http-request="upload"
    >
      <el-button size="small" type="primary" v-loading="uploadLoading">
        点击上传
      </el-button>
    </el-upload>
    <el-dialog
      title="预览"
      :visible.sync="dialogVisible"
      :append-to-body="true"
    >
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "UploadImage",
  props: {
    accept: {
      type: String,
      default: {
        return: "image/*"
      }
    },
    uploadLimit: {
      type: Number
    },
    value: {
      type: String,
      default: {
        return: ""
      }
    }
  },
  data() {
    return {
      uploadLoading: false,
      fileList: [],
      dialogVisible: false,
      dialogImageUrl: ""
    };
  },
  mounted() {},
  methods: {
    // 上传文件之前的钩子
    beforeUpload(file) {
      this.uploadLoading = true;
    },
    // 文件列表移除文件时的钩子
    onRemove(file, fileList) {
      // console.log(file, fileList)
      this.deleteFile(file.url);
      this.fileList = fileList;
      if (fileList.length > 0) {
        let list = fileList.map((item) => {
          return item.url;
        });
        this.$emit("input", list.toString());
      } else {
        this.$emit("input", "");
      }
    },
    // 文件上传成功时的钩子
    onSuccess(response, file, fileList) {
      // console.log(response, file, fileList)
      this.uploadLoading = false;
      let list = fileList.map((item) => {
        // console.log(item)
        if (item.response) {
          for (const key in item.response.data) {
            return item.response.data[key];
          }
        } else {
          return item.url;
        }
      });
      // this.$emit("input", list.toString());
    },
    async upload(event) {
      // console.log(event,111)
      // return
      let res = await this.$Common.fileUploadNew(event);
      let name = this.getName(res.fileUrl);
      let fileList = this.fileList;
      // console.log(fileList)
      fileList.push({
        name: name,
        url: res.fileUrl
      });
      // console.log(fileList)
      this.uploadLoading = false;
      if (fileList.length > 0) {
        let list = fileList.map((item) => {
          return item.url;
        });
        this.$emit("input", list.toString());
      } else {
        this.$emit("input", "");
      }
    },
    // 文件上传失败时的钩子
    onError(file) {
      this.$message.error("图片上传失败！");
    },
    // 删除文件之前的钩子
    beforeRemove(file) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 文件超出个数限制时的钩子
    onExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 ${this.uploadLimit} 个文件，本次选择了 ${files.length} 个文件`
      );
    },
    // 	点击文件列表中已上传的文件时的钩子
    handlePictureCardPreview(file) {
      if (file.url) {
        this.dialogImageUrl = this.$store.state.config.fileUrl + file.url;
        this.dialogVisible = true;
      }
    },
    getName(str) {
      // console.log(str)
      let arr = str.split("/");
      // console.log(arr);
      return arr[arr.length - 1 ];
    },
    async deleteFile(url) {
      let isDelete = await this.$Common.delFile(url);
      if (isDelete) {
        this.$message({
          type: "success",
          message: "删除成功!"
        });
      }
    }
  },
  computed: {},
  watch: {
    value: {
      handler(newVal, oldVal) {
        if (newVal) {
          let list = newVal.split(",");
          this.fileList = list.map((item) => {
            let data = item.split("/");
            let obj = {};
            obj.name = data.pop();
            obj.url = item;
            return obj;
          });
        } else {
          this.fileList = [];
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scope>
.upload-demo {
  /deep/ input[type="file"] {
    display: none;
  }
}
</style>
